import { createAction, props } from "@ngrx/store";
import { CreditCard, SubscriptionBilling } from "./model";

export const getSubscriptionDetails = createAction("[Subscription Details] getSubscriptionDetails");

export const getSubscriptionDetailsComplete = createAction(
    "[Subscription Details] getSubscriptionDetailsComplete",
    props<{ subscription: any }>()
);

export const getSubscriptionDetailsError = createAction(
    "[Subscription Details] getSubscriptionDetailsError",
    props<{ error: any }>()
);

export const getActiveBillings = createAction("[Subscription Details] getActiveBillings");

export const getActiveBillingsComplete = createAction(
    "[Subscription Details] getActiveBillingsComplete",
    props<{ billings: SubscriptionBilling[] }>()
);

export const getActiveBillingsError = createAction("[Subscription Details] getActiveBillingsError", props<{ error }>());

export const cancelSubscription = createAction("[Subscription Details] cancelSubscription");

export const subscriptionCancelled = createAction("[Subscription Details] cancelled");

export const cancelSubscriptionError = createAction(
    "[Subscription Details] cancelSubscriptionError",
    props<{ error: any }>()
);

export const updateCreditCard = createAction("[Subscription Details] updateCreditCard", props<{ data: CreditCard }>());

export const updateCreditCardComplete = createAction(
    "[Subscription Details] updateCreditCardComplete",
    props<{ result: boolean; data: CreditCard }>()
);

export const updateCreditCardError = createAction(
    "[Subscription Details] updateCreditCardError",
    props<{ error: any }>()
);

export const toggleCreditCardUpdate = createAction("[Subscription Details] toggleCreditCardUpdate");

export const abandonCancellation = createAction("[Subscription] abandonCancellation");

export const abandonCancellationComplete = createAction("[Subscription] abandonCancellationComplete");

export const abandonCancellationError = createAction(
    "[Subscription] abandonCancellationError",
    props<{
        error;
    }>()
);
